<template>
    <div>
        <div class="vrm-drawer__backdrop" @click="handleClose"></div>
        <div v-if="isOpen" class="vrm-drawer mfp-with-anim" :class="{ mobile: isDeviceControls }">
            <div v-if="popUpData.showPopUp && isMobile" class="vrm-overlay" @click.self="hidePopUp">
                <controls-confirmation-mobile-pop-up
                    v-if="isMobile"
                    :pop-up-data="popUpData"
                    @updateShowPopUp="computedShowPopUp($event)"
                    @confirmedChoice="handleConfirmedChoice"
                    @update-confirmed-slider="$emit('update-confirmed-slider', $event)"
                />
            </div>
            <div class="vrm-drawer__title">
                <h2>{{ title }}</h2>
                <vrm-icon-button
                    :icon-class="closeIcon"
                    data-cy="close-drawer-btn"
                    class="vrm-control-settings"
                    @click="handleClose"
                ></vrm-icon-button>
            </div>
            <slot />
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

import VrmIconButton from '../molecules/VrmIconButton';
import controlsConfirmationMobilePopUp from '@/vue/components/shared/device-controls/controls/components/controlsConfirmationMobilePopUp';

@Component({ components: { VrmIconButton, controlsConfirmationMobilePopUp } })
@AngularDirective('vrm-drawer')
export default class VrmDrawer extends Vue {
    @Prop() title;
    @Prop({ required: true }) isOpen;
    @Prop() closeIcon;
    @Prop() isDeviceControls;
    @Prop() isDeviceControlsPopUpOpen;
    @Prop() popUpData;

    isMobile = window.innerWidth <= 750;

    mounted() {
        window.addEventListener('resize', this.handleResize);
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }

    @Watch('isOpen')
    onDrawerToggle() {
        document.body.style.overflow = this.isOpen ? 'hidden' : '';
    }

    handleClose() {
        this.$emit('close');
    }

    handleResize() {
        this.isMobile = window.innerWidth <= 750;
    }

    hidePopUp() {
        this.$emit('updateShowPopUp', { showPopUp: false });
    }

    computedShowPopUp(value) {
        this.$emit('updateShowPopUp', value);
    }

    handleConfirmedChoice(popUpData) {
        this.$emit('confirmedChoice', popUpData);
    }
}
</script>
